import { render, staticRenderFns } from "./SelfieButton.vue?vue&type=template&id=5bff5ae3"
import script from "./SelfieButton.vue?vue&type=script&lang=js"
export * from "./SelfieButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports